<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="copyright-information"><div style="padding-top:180px">
<p>Although the village of Imber, now a</p>
<p>practice range for the British Army,</p>
<p>on Salisbury Plain, gave me he idea for</p>
<p>this novel. The characters and events in</p>
<p>it are entirely fictitious.</p>
<br/>
<p style="text-indent:13em"><strong>C.H.C.</strong></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0003.vue?0ca8b8c6